"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.simulatorGrid = exports.defaultGrid = exports.marginsGeneral = exports.paddingsGeneral = exports.paddingsSimulator = exports.breakpoints = exports.vpBreakpoints = void 0;
exports.vpBreakpoints = {
    VPS: 375,
    VPL: 1440,
};
exports.breakpoints = {
    xs: 0,
    sm: 768,
    md: 1024,
    lg: 1280,
    xl: 1536,
};
exports.paddingsSimulator = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 20,
};
exports.paddingsGeneral = {
    ...exports.paddingsSimulator,
    lg: 40,
};
exports.marginsGeneral = {
    xs: 20,
    sm: 40,
    md: 80,
    lg: 80,
};
exports.defaultGrid = {
    breakpoints: exports.breakpoints,
    paddings: exports.paddingsGeneral,
    margins: exports.marginsGeneral,
};
exports.simulatorGrid = {
    breakpoints: exports.breakpoints,
    paddings: exports.paddingsSimulator,
    margins: exports.marginsGeneral,
};
const grid = {
    defaultGrid: exports.defaultGrid,
    simulatorGrid: exports.simulatorGrid,
    vpBreakpoints: exports.vpBreakpoints,
    breakpoints: exports.breakpoints,
    paddingsGeneral: exports.paddingsGeneral,
    paddingsSimulator: exports.paddingsSimulator,
    marginsGeneral: exports.marginsGeneral,
};
exports.default = grid;
//# sourceMappingURL=grid.js.map